import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import RightArrow from "../common/icons/right-arrow";
import { useTranslation } from 'react-i18next';
import { error, loading, Updateloading } from '../common/helpers/toastify';
import { Api_form } from '../api/_call';
import { Importmodal } from "../common/modules/Importmodal"

const importTypes = {
  databaseFile: "database",
  imagefile: "docsimagefile",
}

const SettingImport = () => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const { t } = useTranslation();
  const [importfile, setImportfile] = useState()
  const [filetype, setFiletype] = useState()
  const [uploadedNames, setUploadedNames] = useState({})
  const [importing, setImporting] = useState(false)

  const readExcel = async () => {
    if (!importfile) {
      error(t('Choose file!'));
      return;
    }
    if (!importfile.name?.toLowerCase().endsWith('.zip')) {
      error(t('Please select a ZIP file'));
      return;
    }
    const currentType = filetype
    setUploadedNames((prev) => ({ ...prev, [currentType]: importfile.name }))
    setImporting(true)
    let GetloadingID = loading()
    try {
      const formData = new FormData()
      formData.append(currentType, importfile)
      formData.append('type', importTypes[currentType])
      let res = await Api_form(
        formData,
        `api/v1/settings/import`,
      )
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, t(res?.message || 'Import completed successfully'))
      } else {
        Updateloading(t, GetloadingID, t(res?.message || res?.errors || 'Something Went Wrong!!'), 'error')
      }
    } catch (err) {
      console.log(err, 'err')
      Updateloading(t, GetloadingID, t('Something Went Wrong!!'), 'error')
    } finally {
      setImporting(false)
    }
  }

  return (
    <div className="main-content-wrapper-body">
      <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
        <div className="main-content-wrapper-body-top-bar-left">
          <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
            <Link className="text-decoration-none" to="/app/admin/settings">{t("Setting")}</Link>  <RightArrow /> <span>{t("Import")}</span>
          </h1>
        </div>
        <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center">
          <button className="square-btn"><img src={base_assets + "images/icons/white-save.png"} alt="" /></button>
        </div>
      </div>
      <div className="admin-main-card">
        <div className="row">
          <div className="col-md-12">
            <div className='row'>
              <div className='col-md-6'>
                <div className="v3-input-group">
                  <label className="v3-input-group-label" >{t("Database import")}</label>
                  <input type="text" className="v3-input-group-input w-100" value={uploadedNames.databaseFile || ''} readOnly />
                </div>
              </div>
              <div className='col-md-6 v3-input-group d-flex align-items-end'>
                <label className={`com-btn cursor-pointer ${importing ? 'pe-none opacity-50' : ''}`} data-bs-toggle="modal"
                  data-bs-target="#ImportModal" onClick={() => setFiletype("databaseFile")}>{t("choose file")}</label>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div className="v3-input-group">
                  <label className="v3-input-group-label">{t("Image ZIP")}</label>
                  <input type="text" className="v3-input-group-input w-100" value={uploadedNames.imagefile || ''} readOnly />
                </div>
              </div>
              <div className='col-md-6 v3-input-group d-flex align-items-end'>
                <label data-bs-toggle="modal"
                  data-bs-target="#ImportModal" className={`com-btn cursor-pointer ${importing ? 'pe-none opacity-50' : ''}`}
                  onClick={() => setFiletype("imagefile")}>{t("choose file")}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Importmodal
        setImportfile={setImportfile}
        readExcel={readExcel}
        importfile={importfile}
        hideSample={true} />
    </div>
  )
}

export default SettingImport
